import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px auto'
  }
};

const enhance = compose();

const button = enhance(
  ({
    classes,
    onClickAction,
    enabled = true,
    textButton = false,
    fullWidth = false
  }) => {
    return (
      <Button
        variant="contained"
        color="primary"
        fullWidth={fullWidth}
        onClick={onClickAction}
        className={classes.button}
        disabled={!enabled}
      >
        {!textButton ? '認証コードを送る' : textButton}
      </Button>
    );
  }
);

export default withRouter(withStyles(styles)(button));
